import { render, staticRenderFns } from "./TechWarning.vue?vue&type=template&id=34d8ff89&scoped=true&"
import script from "./TechWarning.vue?vue&type=script&lang=ts&"
export * from "./TechWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d8ff89",
  null
  
)

export default component.exports